import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, batch } from 'react-redux';

import {
  EDIT_PAUSE_DURATION_MODAL_STAGES,
  setEditDurationModalStage,
  setSelectedRequest,
} from 'features/courseResume';

function EditDurationButton({ request }) {
  const dispatch = useDispatch();

  const handleEditDuration = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(request));
      dispatch(
        setEditDurationModalStage(EDIT_PAUSE_DURATION_MODAL_STAGES.update)
      );
    });
  }, [dispatch, request]);

  return (
    <Tappable
      onClick={handleEditDuration}
      className="primary bold btn-small"
      noHighlight
    >
      Edit Duration
    </Tappable>
  );
}

export default EditDurationButton;
